// extracted by mini-css-extract-plugin
module.exports = {"appListWrapper":"_2QGXbQUHF1kFTDR4-OMXFY","appCellWrapper":"_2dF1sQQILrMkwuWvoHqKET","appList":"bS1eyxAUW-6uz-FeRVYWF"};